function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".windows-cls-1{fill:#f05423;}.windows-cls-2{fill:#84c441;}.windows-cls-3{fill:#2dabe2;}.windows-cls-4{fill:#f9bc15;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "windows-cls-1",
  d: "M125.78,124.64H25.61V24.47H125.78Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "windows-cls-2",
  d: "M236.39,124.64H136.21V24.47H236.39V124.64Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "windows-cls-3",
  d: "M125.78,235.29H25.61V135.12H125.78Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "windows-cls-4",
  d: "M236.39,235.29H136.21V135.12H236.39V235.29Z"
});

var SvgWindows = function SvgWindows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Windows Icon",
    viewBox: "0 0 262 255",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWindows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Windows.fb2410e1.svg";
export { ForwardRef as ReactComponent };